import { useState } from "react";
// this hook will be utilize when managing drawer, modal, pop up, dialog box

const useLoadingState = () => {
  const [LoadingState, setLoadingState] = useState({
    visible: false,
    btnName: "",
  });

  const startLoading = ({ btnName }) => {
    setLoadingState({
      visible: true,
      btnName: btnName || "",
    });
  };

  const stopLoading = () => {
    setLoadingState({
      visible: false,
      btnName: "",
    });
  };

  return { LoadingState, startLoading, stopLoading };
};

export default useLoadingState;
